let bindFonts = document.querySelectorAll('[data-bind="fonts"]');

bindFonts.forEach(binder=> {
	let target = document.querySelector(binder.dataset.target);

	if(!target) return false;

	let spans  = target.querySelectorAll('span');

	spans.forEach(span => span.defaultValue = span.innerHTML);

	binder.addEventListener('input', render);

	function render() {
		spans.forEach(span => {
			if(binder.value === '') {
				span.innerHTML = span.defaultValue;
			}else {
				span.innerHTML = binder.value;
			}
		});
	}
});
